import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { Button, CircularProgress, Grid } from "@mui/material"
import { InfoSection } from './InfoSection'
import { Comments } from './Comments/Comments'
import { useDispatch, useSelector } from 'react-redux'
import { addPictureToNewSystemInfoTC, fetchWorkItemDataTC, setCurrentlyOpendTaskSystemInfo, setCurrentlyOpenedTaskState, setTab, updateTaskTC } from '../TasksList/tasks-reducer'
import { AppRootState } from '../../app/store'
import { TaskStateType, WorkItemType } from '../../api/projects-api'
import { WorkItemAttachments } from './Attachments/WorkItemAttachments'
import { useLocation, useNavigate } from 'react-router-dom'
import { checkAutoLogin } from '../Login/auth-reducer'
import { LocationStateType } from '../TasksList/WorkItem'
import { getLocation, setCurrentLocation } from '../../app/cookies'
import { CommentsPartType } from './Comments/comments-reducer'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { TitleSection } from './TitleSection'
import { GreySection } from './GreySection'
import { InfoSectionFix } from './InfoSectionFix'
import { decreaseUpdatedTasks } from '../Notification/notification-reducer'

export const WorkItemData = React.memo(() => {
  const location = useLocation()
  const stateFromLocation = location.state as LocationStateType
  const projectNameFromCookie = getLocation().projectName
  const dispatch = useDispatch()
  const openedTab = useSelector<AppRootState, string>(state => state.workItems.openedTab)
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  let workItems = useSelector<AppRootState, Array<WorkItemType>>(state => state.workItems.workItemsState[stateFromLocation.projectName])
  let tasksCommentPart = useSelector<AppRootState, Array<CommentsPartType>>(state => state.commentsTaskPart[stateFromLocation.projectName])
  let newSystemInfoFromState = useSelector<AppRootState, string>(state => state.workItems.currentlyOpenedTask.systemInfo)
  const [isButtonActive, setButton] = useState(false)

  const navigate = useNavigate()
  console.log('stateFromLocation', stateFromLocation)

  useEffect(() => {
    let token = checkAutoLogin(dispatch)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    } else {
      if (token !== null && isLoggedIn === false) {
        return navigate(`/project/${projectNameFromCookie}`)
      }

      dispatch(fetchWorkItemDataTC({
        projectId: stateFromLocation.projectId, projectName: stateFromLocation.projectName,
        itemId: stateFromLocation.itemID, token
      }))
    }
    setCurrentLocation(`\\ Projects \\ ${stateFromLocation.projectName} \\ Item #${stateFromLocation.itemID} `)
    dispatch(decreaseUpdatedTasks())


    return () => { dispatch(setTab({ tabName: 'details' })) }
  }, [isLoggedIn])

  if (!workItems) {
    workItems = [] as Array<WorkItemType>
  }
  if (!workItems || workItems.length === 0) {
    return <CircularProgress color='info' style={{ position: 'fixed', top: '30%', left: '50%', width: 80, height: 80 }} />
  }

  let item = workItems.find(w => w.id === stateFromLocation.itemID) as WorkItemType
  if (!item) {
    item = {} as WorkItemType
  }
  let taskCommentsPart = tasksCommentPart.find(t => t.taskId === stateFromLocation.itemID) as CommentsPartType

  const retroSteps = item.fields?.['Microsoft.VSTS.TCM.ReproSteps']
  const htmlString = retroSteps as string
  const workType = item.fields?.["System.WorkItemType"]
  const description = item.fields?.['System.Description'] as string

  let totalCommentCount: number = 0
  if (taskCommentsPart) {
    totalCommentCount = taskCommentsPart.commentsData?.totalCount
  }

  let relations = item.relations
  if (!relations) {
    relations = []
  }
  let attachedFiles = relations.filter(obj => obj.rel === 'AttachedFile')

  const setTaskStateInParent = (newState: TaskStateType) => {
    newState === item.fields?.["System.State"] ? setButton(false) : setButton(true)
    dispatch(setCurrentlyOpenedTaskState({ state: newState }))
  }
  const setNewSystemInfoInParent = (newInfo: string) => {
    newInfo === item.fields?.["Microsoft.VSTS.TCM.SystemInfo"] ? setButton(false) : setButton(true)
    dispatch(setCurrentlyOpendTaskSystemInfo({ systemInfo: newInfo }))
  }

  async function onClickSaveButton() {
    await dispatch(updateTaskTC({ projectName: stateFromLocation.projectName, projectId: stateFromLocation.projectId, taskId: item.id }))
    navigate(`/itemID/${item.id}`, { state: { ...stateFromLocation } })
    setButton(false)
  }
  console.log('ITEM: ', item)

  const addFileToNewSystemInfo = (event: ChangeEvent<HTMLInputElement>) => {

    let file: any
    if (event.target.files) {
      file = event.target.files[0]
      let formData = new FormData()
      formData.append("formdata", file)
      const imgSrc = URL.createObjectURL(file)
      console.log(file)
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/bmp') {
        dispatch(addPictureToNewSystemInfoTC({ imgSrc, projectId: stateFromLocation.projectId, projectName: projectNameFromCookie, fileName: file.name, formData }))
      } else {
        alert('Unsupported file type.  Valid file types are:  jpg, jpeg, png, bmp, gif')
      }
    }
  }

  return <>
    <Grid container spacing={3} >
      <Grid item xl={12} xs={12}>
        <Grid style={{ paddingTop: '30px' }}>
          <Button onClick={(e) => navigate(`/project/${projectNameFromCookie}`)} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
            Back to Work Items
          </Button>
        </Grid>
        <TitleSection onClickSaveButton={onClickSaveButton} isButtonActive={isButtonActive} itemId={item.id} itemTitle={item.fields?.['System.Title']} totalCommentCount={totalCommentCount} workType={workType} />
        <GreySection setTaskStateInParent={setTaskStateInParent} item={item} openedTab={openedTab} attachmentsCount={attachedFiles?.length > 0 ? `(${attachedFiles?.length})` : ''} />

        {openedTab === 'attachments' ? <WorkItemAttachments projectId={stateFromLocation.projectId} projectName={stateFromLocation.projectName} taskId={item.id} />
          :
          <>
            <Grid container className='retroSteps'>
              {workType === 'Bug' ? <InfoSection title={"SystemInfo"} newSystemInfoFromState={newSystemInfoFromState} setNewSystemInfoInParent={setNewSystemInfoInParent} addFileToNewSystemInfo={addFileToNewSystemInfo} />
                : <InfoSectionFix html={description} title="Description" />}
            </Grid>
            {retroSteps ? <Grid container className='retroSteps'>
              <InfoSectionFix html={htmlString} title="Repro Steps" />
            </Grid> : <></>}

            <Comments
              taskCommentsPart={taskCommentsPart}
              relationLength={relations.length}
              item={item}
              projectId={stateFromLocation.projectId} projectName={stateFromLocation.projectName} workItemID={item.id} />
          </>}
      </Grid>
    </Grid>
  </>
})
